import styled from '@emotion/styled';
import { rem } from '@utils';

const Root = styled.article`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(12)};
  container: audience-overlap / inline-size;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
`;

const Header = styled.div`
  padding: ${rem(16)} ${rem(16)} 0;
`;

const HeaderDivider = styled.hr`
  border: 0;
  background-color: ${({ theme }) => theme.palette.grey['200']};
  height: ${rem(1)};
  width: 100%;
`;

const Title = styled.h4`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  margin-bottom: ${rem(16)};
`;

const Body = styled.div`
  display: flex;
  gap: 0;

  @container audience-overlap (max-width: ${rem(640)}) {
    flex-direction: column;
    gap: ${rem(24)};
  }
`;

const DiagramSection = styled.div`
  flex: 1 1 0;
  min-width: 0;
  padding: ${rem(16)} ${rem(16)} ${rem(24)} ${rem(16)};
`;

const VerticalDivider = styled.div`
  align-self: stretch;
  background: ${({ theme }) => theme.palette.grey['200']};
  flex-shrink: 0;
  width: ${rem(1)};
  margin-bottom: ${rem(16)};
`;

const StatsSection = styled.div`
  display: flex;
  flex: 0 0 ${rem(240)};
  flex-direction: column;
  gap: ${rem(16)};
  justify-content: center;
  min-width: ${rem(200)};
  padding: ${rem(32)};

  @container audience-overlap (max-width: ${rem(640)}) {
    flex: 1 1 auto;
    flex-direction: row;
    min-width: 0;
    width: 100%;
  }
`;

const StatGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};

  @container audience-overlap (max-width: ${rem(640)}) {
    flex: 1 1 0;
    min-width: 0;
    position: relative;
  }
`;

const StatDivider = styled.hr`
  border: 0;
  border-top: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
  margin: 0;
  width: 100%;

  @container audience-overlap (max-width: ${rem(640)}) {
    border-left: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
    border-top: 0;
    bottom: 0;
    left: -${rem(8)};
    position: absolute;
    top: 0;
    width: 0;
  }
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};

  @container audience-overlap (max-width: ${rem(640)}) {
    min-width: 0;
  }
`;

const StatValue = styled.p`
  font-size: ${rem(24)};
  font-weight: 400;
  line-height: ${rem(32)};
  margin: 0;
`;

const StatLabel = styled.p`
  font-size: ${rem(12)};
  font-weight: 400;
  line-height: ${rem(16)};
  margin: 0;
`;

export default {
  Root,
  Header,
  HeaderDivider,
  Title,
  Body,
  DiagramSection,
  VerticalDivider,
  StatsSection,
  StatGroup,
  StatDivider,
  Stat,
  StatValue,
  StatLabel
};
